<section class="contacts_list">
   
    <div class="list_wrapper">
         <div class="btn_wrapper">
        <button (click)="openAddNewContacts()" class="btn_plain_color" id="add_contact_btn">
            <h4>Add new contact</h4><img src="../assets/icons/person_add.svg" alt="">
        </button>
    </div>

        <div *ngIf="isDialogOpen" class="overlay_content" (click)="closeDialog()">
            <div class="custom-dialog">
                <app-add-contact-dialog (closeDialogEvent)="closeDialog()" (contactCreatedEvent)="openDialogDetails($event)" (click)="stopPropagation($event)"></app-add-contact-dialog>
            </div>
        </div>

        @if(firebase.orderedContactsList) {
            @for (item of firebase.orderedContactsList; track $index) {
            @if($index === 0 || item.firstname.charAt(0) !== firebase.orderedContactsList[$index - 1].firstname.charAt(0) )
                {<h4 class="single_letter">{{ item.firstname.charAt(0) }}</h4>}
                <div class="contact_info_wrapper" (click)="openDialogDetails(firebase.orderedContactsList[$index])"
                [ngClass]="{'selected-contact': selectedContactEmail === item.email}">
                    <div class="avatar" [ngStyle]="{'background-color': item.color}">
                        <p>{{item.firstname.charAt(0)}}{{item.lastname.charAt(0)}}</p>
                    </div>
                    <div class="contact_info">
                        <p class="name">{{item.fullname.length > 12 ? (item.fullname.slice(0, 12) + '...') : item.fullname | titlecase }}</p>
                        <p class="email">{{item.email.length > 12 ? (item.email.slice(0, 12) + '...') : item.email}}</p>    
                    </div>     
                </div>
            } @empty {
                <div>data loading</div>
            }
        }
    </div>

    <div class="three_dot_menu" (click)="openAddNewContacts()">
        <img src="./assets/contact/add-contact.svg" alt="">
    </div>
</section>